import useConfigValues from '../../ReduxFunctions/useConfigValues';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchData } from '../../Helpers/externapi';
import { setHospitalImage } from '../../ReduxFunctions/ReduxSlice';

const useCustomersController = () => {
    const configValues = useConfigValues('hospitalImagesURL');
    const hospitalImage = useSelector((state) => state.hospitalImage);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [windowSize, setWindowSize] = useState({ width: window.innerWidth, height: window.innerHeight });
    const [appointments, setAppointments] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const hospitalId = sessionStorage.getItem('hospitalId');
    const hospitalName = sessionStorage.getItem('hospitalName');
    const hospitalLogo = sessionStorage.getItem('hospitalImage');

    useEffect(() => {
        const handleResize = () => {
            setWindowSize({ width: window.innerWidth, height: window.innerHeight });
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const fetchHospitalAppointments = async () => {
            try {
                setIsLoading(true);
                const response = await fetchData('BookingConsultation/ConsultationListByHospitalId', {
                    skip: 0,
                    take: 0,
                    HospitalId: hospitalId,
                });
                setAppointments(response?.data || []);
            } catch (error) {
                console.error('Error fetching BookingConsultation/ConsultationListByHospitalId:', error);
                setAppointments([]);
            } finally {
                setIsLoading(false);
            }
        };

        fetchHospitalAppointments();
    }, [hospitalId]);

    useEffect(() => {
        if (!configValues.length || hospitalImage.length) {
            return;
        }

        const imageUrl = configValues.find((value) => value.ConfigKey === 'hospitalImagesURL');
        if (imageUrl && hospitalLogo) {
            dispatch(setHospitalImage(imageUrl.ConfigValue + hospitalLogo));
        }
    }, [configValues, dispatch, hospitalImage, hospitalLogo]);

    return {
        appointments,
        goToDashboard: () => navigate('/dashboard'),
        goToVerification: () => navigate('/verify'),
        hospitalImage,
        hospitalLogo,
        hospitalName,
        isLoading,
        windowSize,
    };
};

export default useCustomersController;
